export default __webpack_public_path__ + "static/media/UsersManagementIcon.e2b4624d.svg";